import { useDragDropContext } from "../../../../../../utilities/drag-drop";
import { ChangePageBarVariant } from "../../../../../../utilities/layout/constants";
import { useLayoutProvider } from "../../../../utils/layout";
import { ChangePageBar } from "../ChangePageBar";

export function QuickListChangePageBars() {
  const { draggingComponentRef } = useDragDropContext();
  const { isEditing, pagesController } = useLayoutProvider();

  const {
    addEmptyPage,
    goToNextPage,
    goToPreviousPage,
    hasPreviousPage,
    hasNextPage,
  } = pagesController;

  const isChangeBarVisible = !!draggingComponentRef.current && isEditing;

  const leftPageBarMarkup = (
    <ChangePageBar
      variant={ChangePageBarVariant.Left}
      onEnter={goToPreviousPage}
      visible={isChangeBarVisible && hasPreviousPage}
    />
  );

  const rightPageBarMarkup = hasNextPage ? (
    <ChangePageBar
      variant={ChangePageBarVariant.Right}
      onEnter={goToNextPage}
      visible={isChangeBarVisible && hasNextPage}
    />
  ) : (
    <ChangePageBar
      variant={ChangePageBarVariant.Add}
      onEnter={addEmptyPage}
      visible={isChangeBarVisible && !hasNextPage}
    />
  );

  return (
    <>
      {leftPageBarMarkup}
      {rightPageBarMarkup}
    </>
  );
}
